export class DefaultPropertyType {
  name: string;
  unit: string;
  dataType: string;

  constructor(name?: string, unit?: string, dataType?: string) {
    this.name = name;
    this.unit = unit;
    this.dataType = dataType;
  }
}
